var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":""}}),_c('a',{staticStyle:{"cursor":"pointer !important"},on:{"click":function($event){_vm.inImageUpload = true}}},[_vm._v("Upload")])])}
var staticRenderFns = []

export { render, staticRenderFns }